/**
 * Conversion features: welcome popup, exit-intent popup, recently-purchased
 * toast rotator, and the back-in-stock modal. Each is independently gated
 * so merchants can toggle them off in Theme Settings without touching code.
 */
(function () {
  'use strict';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function openModal(modal) {
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    var overlay = $('[data-overlay]');
    if (overlay) overlay.classList.add('is-visible');
  }
  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    var overlay = $('[data-overlay]');
    var anyOpen = document.querySelector('.modal.is-open, .drawer.is-open');
    if (overlay && !anyOpen) overlay.classList.remove('is-visible');
  }

  /* ---------------- Welcome popup ---------------- */
  function initWelcomePopup() {
    var modal = $('[data-welcome-popup]');
    if (!modal) return;
    var key = 'wallz:welcomePopupSeen';
    if (WallZ.utils.getStorage(key, false)) return;
    var delay = (window.WallZ.settings && window.WallZ.settings.welcomePopupDelay) || 6;
    var timer = setTimeout(function () {
      openModal(modal);
      WallZ.utils.setStorage(key, true);
    }, delay * 1000);
    modal.querySelectorAll('[data-welcome-popup-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { clearTimeout(timer); closeModal(modal); });
    });
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(modal); });
  }

  /* ---------------- Exit intent popup ---------------- */
  function initExitIntent() {
    var modal = $('[data-exit-intent-popup]');
    if (!modal) return;
    var sessionKey = 'wallz:exitIntentShown';
    if (sessionStorage.getItem(sessionKey)) return;
    function trigger(e) {
      if (e.clientY > 20) return;
      openModal(modal);
      sessionStorage.setItem(sessionKey, '1');
      document.removeEventListener('mouseleave', trigger);
    }
    document.addEventListener('mouseleave', trigger);
    modal.querySelectorAll('[data-exit-intent-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { closeModal(modal); });
    });
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(modal); });
  }

  /* ---------------- Recently purchased toast ---------------- */
  function initRecentSaleToast() {
    var toast = $('[data-recent-sale-toast]');
    var dataEl = $('[data-recent-sale-data]');
    if (!toast || !dataEl) return;
    var entries;
    try { entries = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!entries || !entries.length) return;

    var dismissedKey = 'wallz:recentSaleDismissed';
    if (WallZ.utils.getStorage(dismissedKey, false)) return;

    var textEl = $('[data-recent-sale-text]', toast);
    var timeEl = $('[data-recent-sale-time]', toast);
    var index = 0;

    function show() {
      var entry = entries[index % entries.length];
      textEl.textContent = entry.name + ' in ' + entry.location + ' bought ' + entry.product;
      timeEl.textContent = entry.time + ' ago';
      toast.hidden = false;
      requestAnimationFrame(function () { toast.classList.add('is-visible'); });
      index++;
      setTimeout(hide, 5500);
    }
    function hide() {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.hidden = true; }, 400);
    }

    setTimeout(show, 8000);
    var interval = setInterval(show, 22000);

    toast.querySelector('[data-recent-sale-close]').addEventListener('click', function () {
      hide();
      clearInterval(interval);
      WallZ.utils.setStorage(dismissedKey, true);
    });
  }

  /* ---------------- Back in stock modal ---------------- */
  function initBackInStock() {
    var modal = $('[data-back-in-stock-modal]');
    var trigger = $('[data-back-in-stock-trigger]');
    if (!modal) return;
    if (trigger) {
      trigger.addEventListener('click', function () {
        var productJson = $('[data-product-json]');
        var title = productJson ? JSON.parse(productJson.textContent).title : '';
        var nameEl = $('[data-back-in-stock-product-name]', modal);
        if (nameEl) nameEl.textContent = title;
        var tagInput = $('[data-back-in-stock-tag-input]', modal);
        if (tagInput && title) tagInput.value = 'back-in-stock-request,' + title.toLowerCase().replace(/\s+/g, '-');
        openModal(modal);
      });
    }
    modal.querySelectorAll('[data-back-in-stock-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { closeModal(modal); });
    });
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(modal); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initWelcomePopup();
    initExitIntent();
    initRecentSaleToast();
    initBackInStock();
  });
})();
